import { Utils } from '@/libs/Utils'
import React from 'react'
import { Col, Form } from "react-bootstrap"

const Company: React.FC<{ locale: string, col?: number }> = ({ locale, col = 6 }) => {

    const t = new Utils(locale).Translation
    return (
        <>
            <Form.Group as={Col} md={col} xs={12}>
                <Form.Label>{t("form.company")} <span className="text-danger">*</span></Form.Label>
                <Form.Control required name="company"
                />
                <Form.Control.Feedback type="invalid">[{t("form.company")}]
                    {t("required.message")}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    )
}

export default Company